export const PROFILE_PICTURE_KVS_KEY = 'profile_picture';
export const CROP_AREA_ASPECT = 1 / 1;
